export default __webpack_public_path__ + "static/media/miut_streets_preview.b94ee3f9.png";